import { createElement, memo, useMemo } from '@max/max';
import View from '@hfe/max-view';
import './index.scss';
const Recommend1 = (props) => {
    const week = {
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        Sunday: '周日'
    };
    const radiusStyle = useMemo(() => {
        return {
            backgroundColor: props.bgColor
        };
    }, [props.bgColor]);
    const btStyle = useMemo(() => {
        return {
            backgroundColor: props.btColor
        };
    }, [props.btColor]);
    return <View>
      <View className='price-logo' onClick={() => props.jump(props.city, props.index)} style={{
        width: 'fit-content'
    }}>
        <View className='top-radius' style={radiusStyle}></View>
        <View className='left-content'>
          <View className='city'>
            {props.city.departCityName + '-' + props.city.arriveCityName}
          </View>
          <View className='font-grey'>
            {props.city.date.substr(5) + ' ' + week[props.city.week]}
          </View>
        </View>
        <View className="right-content font-white" style={btStyle}>
          <View className="price">￥{props.city.price}</View>
          <View className="">{props.city.discout > 0 ? `${props.city.discout / 10}折` : ''}</View>
        </View>
        <View className='bottom-radius' style={radiusStyle}></View>
      </View>
    </View>;
};
export default memo(Recommend1);
